export default "__VITE_ASSET__DjEX6XGE__"